function initClickListeners() {
  document.addEventListener("click", function (event) {
    /*                      */
    const target = event.target;

    if (target.classList.contains("js_pl_banner__close")) {
      const message = target.closest(".pl_banner");

      if (message) {
        message.style.display = "none";
      }
    }
  });
}

window.o_global.eventLoader.onReady(10, initClickListeners);
